document.documentElement.classList.remove('no-js');

class OveniqoMenu extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-menu-toggle]');
    this.panel = this.querySelector('[data-menu-panel]');
    this.closeButton = this.querySelector('[data-menu-close]');
    if (!this.button || !this.panel) return;
    this.button.addEventListener('click', () => this.toggle());
    if (this.closeButton) this.closeButton.addEventListener('click', () => this.close());
    this.querySelectorAll('a').forEach(a => a.addEventListener('click', () => this.close()));
    document.addEventListener('keydown', event => { if (event.key === 'Escape') this.close(); });
  }
  toggle() { this.panel.hidden ? this.open() : this.close(); }
  open() { this.panel.hidden = false; this.button.setAttribute('aria-expanded','true'); document.body.classList.add('menu-open'); }
  close() { this.panel.hidden = true; this.button.setAttribute('aria-expanded','false'); document.body.classList.remove('menu-open'); }
}
customElements.define('ov-menu', OveniqoMenu);

document.addEventListener('change', event => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const form = select.closest('form');
  if (form) form.querySelector('[name="id"]').value = option.value;
  const price = document.querySelector('[data-product-price]');
  if (price && option.dataset.price) price.innerHTML = option.dataset.price;
  const button = form && form.querySelector('[name="add"]');
  if (button) { button.disabled = option.disabled; button.textContent = option.disabled ? 'Sold out' : 'Add to cart'; }
  document.querySelectorAll('[data-sticky-buy] [name="id"]').forEach(input => { input.value = option.value; });
});

document.querySelectorAll('[data-gallery-thumb]').forEach(button => button.addEventListener('click', () => {
  const gallery = button.closest('[data-gallery]');
  const target = gallery && gallery.querySelector(`[data-media-id="${button.dataset.galleryThumb}"]`);
  if (target) target.scrollIntoView({behavior:'smooth', block:'nearest', inline:'start'});
}));

const sticky = document.querySelector('[data-sticky-buy]');
const mainBuy = document.querySelector('[data-main-buy]');
if (sticky && mainBuy && 'IntersectionObserver' in window) {
  new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), {threshold:0}).observe(mainBuy);
}